import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import "react";
import "../../../foundations/icons/IconsDefault.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
const progressContainer = "_progressContainer_196kj_1";
const progressLabel = "_progressLabel_196kj_8";
const progressElement = "_progressElement_196kj_12";
const styles = {
  progressContainer,
  progressLabel,
  progressElement
};
const Progress = ({ label, max, value, id, className, ...props }) => /* @__PURE__ */ jsxs("div", { className: clsx(styles.progressContainer, className), ...props, children: [
  /* @__PURE__ */ jsx(
    "progress",
    {
      id,
      max,
      value,
      "aria-labelledby": `${id}-label`,
      "aria-valuenow": value,
      "aria-valuemax": max,
      className: styles.progressElement,
      children: value && `${(value > max ? 100 : value / max * 100).toFixed(2)}%`
    }
  ),
  /* @__PURE__ */ jsx(Text, { id: `${id}-label`, variant: "text-caption-head", className: styles.progressLabel, children: label })
] });
export {
  Progress
};
